import get_rest_instance from "../../shared/services/common.service";

class FleetService {
  getFleetDataService() {
    return get_rest_instance("server").get("/fleets");
  }
}

export default new FleetService();
